import axios from "axios"
import { MessageBox, Notification } from 'element-ui'
const basePathUrl = 'linkdrive/plataforma/acesso-publico/anuncio/fluxo-confirma-compra'

const state = {
  pedido: null,
  isCommented: false,
  isSendingComent: false,
  comentario: null,
}

const getters = {
  pedido: state => state.pedido,
  comentario: state => state.comentario,
  isCommented: state => state.isCommented,
  isSendingComent: state => state.isSendingComent,
}   

const mutations = {
  SET_PEDIDO(state, pedido) {
    state.pedido = pedido
  },
  SET_IS_SENDING_COMENT(state, isSendingComent) {
    state.isSendingComent = isSendingComent
  },
  SET_COMENTARIO(state, comentario) {
    state.comentario = comentario
  },
  SET_IS_COMMENTED(state, isCommented) {
    state.isCommented = isCommented
  },
}

const actions = {
  async getPedido({ commit, state }, id) {
    if (!id || !!state?.pedido?.id_anuncio) return

    
    const { data: [pedido] } = await axios(`${basePathUrl}/${id}`)
    commit('SET_PEDIDO', pedido)
    
    const purchaseCommented = window.localStorage.getItem(`purchase-commented-${id}`)
    if (purchaseCommented) {
      commit('SET_IS_COMMENTED', true)
      commit('SET_COMENTARIO', JSON.parse(purchaseCommented))
    }
  },

  setPedido({ commit }, pedido) {
    commit('SET_PEDIDO', pedido)
  },

  async sendComment({ commit }, { id, ...params}) {
    if (!params.avaliacao) {
      MessageBox.alert('Por favor, preencha todos os campos!', 'Atenção', {
        confirmButtonText: 'OK',
        type: 'warning'
      }); 
      return
    }
    
    commit('SET_IS_SENDING_COMENT', true)
    await axios.post(`${basePathUrl}/comentario-classificacao/${id}`, params).then(() => {
      Notification({
        title: 'Sucesso',
        message: 'Avaliação enviada com sucesso!',
        type: 'success',
        duration: 7000,
        position: 'bottom-right'
      });

      commit('SET_IS_COMMENTED', true)
      window.localStorage.setItem(`purchase-commented-${id}`, JSON.stringify(params))
    }).catch(() => {
      Notification({
        title: 'Erro',
        message: 'Erro ao enviar avaliação, por favor tente novamente!',
        type: 'error',
      });
    }).finally(() => {
      commit('SET_IS_SENDING_COMENT', false)
    });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}